import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { request } from "utils/request";

// Thunk for verifying email
export const verifyEmail = createAsyncThunk(
  "verifyEmail/verifyEmail",
  async (verificationData, { rejectWithValue }) => {
    try {
      const data = await request(
        `${process.env.REACT_APP_API_URL}/auth/cognito/confirm-email/`,
        {
          method: "POST",
          body: JSON.stringify({
            email: verificationData.email,
            code: verificationData.code,
          }),
        }
      );
      return data;
    } catch (error) {
      return rejectWithValue({
        code:
          error?.message ||
          error?.error ||
          "Email verification failed. Please try again.",
      });
    }
  }
);

// Thunk for resending verification code
export const resendVerificationCode = createAsyncThunk(
  "verifyEmail/resendCode",
  async (email, { rejectWithValue }) => {
    try {
      const data = await request(
        `${process.env.REACT_APP_API_URL}/auth/cognito/resend-confirmation-code/`,
        {
          method: "POST",
          body: JSON.stringify({ email }),
        }
      );
      return data;
    } catch (error) {
      if (error && typeof error === "object" && error.status) {
        return rejectWithValue(error);
      }
      return rejectWithValue(
        "Failed to resend verification code. Please try again."
      );
    }
  }
);

const initialState = {
  isLoading: false,
  verifyEmailError: null,
  codeError: null,
  resendCodeError: null,
  success: false,
  resendSuccess: false,
};

const verifyEmailSlice = createSlice({
  name: "verifyEmail",
  initialState,
  reducers: {
    clearErrors: (state) => {
      state.verifyEmailError = null;
      state.resendCodeError = null;
      state.codeError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Verify Email cases
      .addCase(verifyEmail.pending, (state) => {
        state.isLoading = true;
        state.verifyEmailError = null;
        state.codeError = null;
      })
      .addCase(verifyEmail.fulfilled, (state) => {
        state.isLoading = false;
        state.success = true;
        state.verifyEmailError = null;
        state.codeError = null;
      })
      .addCase(verifyEmail.rejected, (state, action) => {
        state.isLoading = false;
        state.verifyEmailError = action.payload;
        state.codeError = action.payload?.code || null;
      })
      // Resend Code cases
      .addCase(resendVerificationCode.pending, (state) => {
        state.isLoading = true;
        state.resendCodeError = null;
      })
      .addCase(resendVerificationCode.fulfilled, (state) => {
        state.isLoading = false;
        state.resendSuccess = true;
        state.resendCodeError = null;
      })
      .addCase(resendVerificationCode.rejected, (state, action) => {
        state.isLoading = false;
        state.resendCodeError = action.payload;
      });
  },
});

export const { clearErrors } = verifyEmailSlice.actions;
export default verifyEmailSlice.reducer;
